import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";
import { API_URL } from "../../components/01_config/api";

// const API_URL = "http://localhost:4000";

// GET /me/lessons
export const fetchStudentLessons = createAsyncThunk(
  "studentLessons/fetchStudentLessons",
  async (_, { getState, rejectWithValue, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth?.token; // uses your auth slice

      if (!token) {
        return rejectWithValue("Not authenticated");
      }

      const res = await fetch(`${API_URL}/me/lessons`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        let message = `Error ${res.status}`;
        let body = null

        try {
          const body = await res.json();
          if (body?.error) message = body.error;
          if (body?.message) message = body.message;
        } catch (_) {}
        // return rejectWithValue(message);
        if (res.status === 401 || res.status === 403) {
            dispatch(logout())
        }
        return rejectWithValue(message)
      }



      const data = await res.json();
      // [{ lessonId, isUnlocked, isCompleted }, ...]
      return data;
    } catch (err) {
      return rejectWithValue(err.message || "Network error");
    }
  }
);

const studentLessonsSlice = createSlice({
  name: "studentLessons",
  initialState: {
    lessons: [],   // array of { lessonId, isUnlocked, isCompleted }
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentLessons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentLessons.fulfilled, (state, action) => {
        state.loading = false;
        state.lessons = action.payload || [];
      })
      .addCase(fetchStudentLessons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load lessons";
      })
      .addCase(logout,(state) => {
        state.lessons = []
        state.loading = false
        state.error = null
      } 
    
    )
  },
});

export default studentLessonsSlice.reducer;
